<div class="dialog-content">

    <h2>{{ isEditMode ? 'Modifier' : 'Information' }} groupe extensions</h2>

    <form [formGroup]="form" class="form-fields">

        <!-- Extension -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Extension</mat-label>
            <input matInput [value]="data.extension.number" disabled />
        </mat-form-field>

        <!-- Nom -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nom</mat-label>
            <input matInput formControlName="name" placeholder="Nom du groupe" />
        </mat-form-field>

        <!-- Distribution -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Distribution</mat-label>
            <mat-select formControlName="dialerType">
                @for (option of dialerTypeOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <!-- Actif -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Actif</mat-label>
            <mat-select formControlName="enabled">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
            </mat-select>
        </mat-form-field>

    </form>

    <h3>Membres du groupe :</h3>
    @if (!isEditMode) {
    <table mat-table [dataSource]="members" class="mat-elevation-z2">
        <ng-container matColumnDef="extension">
            <th mat-header-cell *matHeaderCellDef>Extension</th>
            <td mat-cell *matCellDef="let member">{{ member.number }}</td>
        </ng-container>
        <ng-container matColumnDef="account">
            <th mat-header-cell *matHeaderCellDef>Identifiant</th>
            <td mat-cell *matCellDef="let member">{{ member.account }}</td>
        </ng-container>
        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef>Nom</th>
            <td mat-cell *matCellDef="let member">{{ member.lastName || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef>Prénom</th>
            <td mat-cell *matCellDef="let member">{{ member.firstName || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let member">{{ member.email || '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="blocked">
            <th mat-header-cell *matHeaderCellDef>Bloqué</th>
            <td mat-cell *matCellDef="let member">{{ member.activeState === 0 ? 'oui' : 'non' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedMemberColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedMemberColumns"></tr>
    </table>
    } @else {
    <!-- Drag & drop des membres -->
    <div class="members-editor drag-container" cdkDropListGroup>
        <div class="member-list">
            <h4>Hors Groupe</h4>
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>Rechercher...</mat-label>
                <input matInput [(ngModel)]="searchTerm" placeholder="Numéro ou nom">
            </mat-form-field>

            <div cdkDropList id="available" [cdkDropListData]="availableExtensions" class="drop-zone"
                (cdkDropListDropped)="drop($event)">
                @for (ext of filteredAvailableExtensions; track ext.id) {
                <div class="drag-item" cdkDrag>{{ ext.number }} - {{ ext.name }}</div>
                }
            </div>
        </div>

        <div class="member-list">
            <h4>Groupe</h4>
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>Rechercher...</mat-label>
                <input matInput [(ngModel)]="searchTerm" placeholder="Numéro ou nom">
            </mat-form-field>
            <div cdkDropList id="selected" [cdkDropListData]="selectedExtensions" class="drop-zone"
                (cdkDropListDropped)="drop($event)">
                @for (ext of selectedExtensions; track ext.id) {
                <div class="drag-item" cdkDrag>
                    {{ ext.number }} –
                    @if (ext.lastName || ext.firstName) {
                    <span>
                        ({{ ext.lastName || '—' }} {{ ext.firstName || '' }})
                    </span>
                    }
                    @if (!ext.lastName && !ext.firstName) {
                    <span>
                        {{ ext.name }}
                    </span>
                    }
                </div>
                }
            </div>
        </div>
    </div>
    }

    @if (!isEditMode) {
    <app-historique [uidObject]="data.extension.id" [limit]="5" />
    }

    <div class="dialog-actions">
        <button mat-stroked-button class="accent-button" (click)="close()">Fermer</button>
        @if (isEditMode) {
        <button mat-raised-button class="accent-button" (click)="save()">Valider</button>
        }
    </div>
</div>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="false"></ngx-spinner>